import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Lang } from '@debbie/common/dist/lang/Lang.js';
import AllLanguagesInput from '../AllLanguagesInput.js';
import { Tabs, TabList, Tab, TabPanel } from '../Tabs.js';
import TemplateEditor from './TemplateEditor/index.js';
const TemplateEditorTabSet = (props) => {
    const { templateId } = props;
    const lang = useSelector((s) => s.lang);
    const [caseId, setCaseId] = useState(null);
    const updateCaseId = (caseId) => setCaseId(caseId);
    const [language, setLanguage] = useState(Lang.da);
    return (React.createElement("div", { style: { width: '100%', maxWidth: '1200px', margin: '0 auto' } },
        React.createElement(Tabs, { style: { backgroundColor: 'transparent' }, defaultIndex: 0 },
            React.createElement(TabList, null,
                React.createElement(Tab, null, lang.templates.standard),
                React.createElement(Tab, null, lang.templates.alternativeContact)),
            React.createElement(AllLanguagesInput, { language: language, onChange: (l) => setLanguage(l) }),
            React.createElement("div", null,
                React.createElement(TabPanel, null,
                    React.createElement(TemplateEditor, { caseId: caseId, setCaseId: updateCaseId, templateId: templateId, ac: false, selectedLanguage: language, preventDelete: props.preventDelete })),
                React.createElement(TabPanel, null,
                    React.createElement(TemplateEditor, { caseId: caseId, setCaseId: updateCaseId, templateId: templateId, ac: true, selectedLanguage: language, preventDelete: props.preventDelete }))))));
};
export default TemplateEditorTabSet;
//# sourceMappingURL=TemplateEditorTabSet.js.map